import roleDisplay from "./role-display";

export default function registerDirectives(Vue) {
  roleDisplay(Vue);
}
